module.exports = __webpack_public_path__ + "media/images/pic/contact/valentyna-kulinich-07834f1901ddb729d24e4ef9b8deda3b.jpeg";